export {
  default,
  DataInfoCardVariant,
  DataInfoCardOrientation,
} from "./DataInfoCard";
